import React from 'react';
import { Item, ItemIcon, ItemTitle, Icon } from '~ui';

export default function SettingsIntegrationsReadyItem({
  href,
  icon = 'integrations',
  title,
}) {
  return (
    <Item as='a' href={href} target='_blank'>
      <ItemIcon>
        <Icon name={icon} />
      </ItemIcon>
      <ItemTitle>{title}</ItemTitle>
    </Item>
  );
}
